import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import ProductCard from '~/components/molecules/Global/ProductCard.vue';
import { MERCURE_OPENING_STATUS } from '~/const/orders';

const MdmModal = () => import(
/* webpackChunkName: "modal" */
'~/components/atoms/Global/MdmModal.vue');

export default {
  name: 'CustomProductAddToCartModal',
  components: {
    MdmModal,
    ProductCard
  },
  props: {
    products: {
      type: Array,
      required: true
    },
    showModal: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      quantity: 1,
      show: false
    };
  },

  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    cartUrl() {
      const openingStatus = this.$cookies.get('MDM_TEST_MERCURE') || MERCURE_OPENING_STATUS[this.locale.iso];
      return this.buildCartUrl(this.locale, openingStatus);
    }

  })
};